import { Element } from '../types/enums';

// Emotion display colors — placeholder hues until the story locks the final
// emotion names / art direction. High saturation + distinct hues for
// on-screen damage-text legibility.
export const ELEMENT_COLORS: Record<Element, string> = {
  joy: '#ffcf3a',
  sadness: '#4aa3ff',
  anger: '#ff4530',
  fear: '#9b6dff',
  surprise: '#ff7ad9',
  disgust: '#5fd06a',
  neutral: '#e8e8e8',
};
